import styled, { css } from 'styled-components';
import { getGenericPanelPadding } from '../../../styles/helpers';
/**
 * Panel content container
 */
export const panelContentContainerStyles = () => css `
	${getGenericPanelPadding(['right', 'left'])}

	*:first-child {
		margin-top: 0;
	}

	*:last-child {
		margin-bottom: 0;
	}
`;
export const PanelContentContainer = styled.div `
	${panelContentContainerStyles}
`;
